// entries/th-TH.ts
import antdTh from "antd/lib/locale/th_TH"
import thMessages from "../locales/th_TH.json"

const ThLang = {
  messages: {
    ...thMessages
  },
  antd: antdTh,
  locale: "th-TH"
}

export default ThLang
